(function() {
  'use strict';
  
  var cartBtn = document.getElementById('cart-button');
  var addCartBtn = document.getElementById('AddToCart-product-template');
  
  var cart = document.querySelector('.Shopify-Cart');
  var closeBtn = cart.querySelector('.close-button');
  var listing = cart.querySelector('.listing');
  var priceEl = cart.querySelector('footer .concept:nth-child(1) div:nth-child(2)');
  var shippingEl = cart.querySelector('footer .concept:nth-child(2) div:nth-child(2)');
  
  /**
   * Gets price from cart weight.
   * @param {number} weight  
   */
  function getPriceFromWeight(weight, days) {
    var roundedWeight = Math.ceil(weight / 1000);
    var price;

    switch(roundedWeight) {
      case 0: price = 130; break;
      case 1: price = 130; break;
      case 2: price = 140; break;
      case 3: price = 145; break;
      case 4: price = 150; break;
      case 5: price = 150; break;
      case 6: price = 175; break;
      case 7: price = 175; break;
      case 8: price = 175; break;
      case 9: price = 175; break;
      case 10: price = 190; break;
      case 11: price = 195; break;
      case 12: price = 195; break;
      case 13: price = 195; break;
      case 14: price = 195; break;
      case 15: price = 220; break;
      case 16: price = 230; break;
      case 17: price = 230; break;
      case 18: price = 230; break;
      case 19: price = 230; break;
      case 20: price = 230; break;
      default: price = 760; break;
    }
    
    // Returns price in cents.
    return price * 100;
  }  
  
  /**
   * Show or hide cart.
   */
  function toggleCart() {
    if (cart.classList.contains('displayed')) {
      cart.classList.remove('displayed');
    } else {
      cart.classList.add('displayed');
      listing.classList.add('loading');
      
      setTimeout(function() {
        updateCartPanel(function () { 
          listing.classList.remove('loading'); 
        });
      }, 1500);
    }
  }
  
  /**
   * Add product to cart.
   * @param {number} id 
   * @param {number} quantity
   * @param {object} properties
   * @param {function} callback
   */
  function addProduct(id, quantity, properties, callback) {
    jQuery.post('/cart/add.js', {
      id: id, 
      quantity: quantity,
      properties: properties
    }, callback);
  }
  
  /**
   * Get cart.
   * @param {function} callback
   */
  function getCart(callback) {
    jQuery.getJSON('/cart.js', callback);
  }
  
  /**
   * Change products in cart.
   * @param {object} updates
   * @param {function} callback 
   */
  function changeCart(updates, callback) {
    jQuery.post('/cart/change.js', updates, callback, 'json');
  }
  
  /**
   * Create list items.
   * @param {Array} items
   */
  function updateItem() {
  	
  }
  
  /**
   * Disable or enable an item.
   * @param {HTMLElement|Node} item
   * @param {boolean} disable
   */
  function disableItem(item, disable) {
    if (disable) {
      item.classList.add('disabled');
    } else {
      item.classList.remove('disabled');
    }
  }
  
  /**
   * Recognize items in list to add functionality.
   */
  function recognizeItems() {
    var items = listing.querySelectorAll('.item');
    
    for (var i = 0; i < items.length; i++) {
      (function(item) {
        var plus = item.querySelector('.button.plus'),
            minus = item.querySelector('.button.minus'),
            input = item.querySelector('input[type=text]'),
            removeItem = item.querySelector('.remove-item'),
            variantid = parseInt(input.dataset['variantid']),
            quantity = parseInt(input.value);
        
        // Event handlers.
        input.addEventListener('change', function(e) {
          var value = Number(e.target.value);
          
          disableItem(item, true);
          if (value !== NaN) {
            changeCart({ id: variantid, quantity: value}, function(obj) {
              updateCartPanel();
              disableItem(item, false);
            });
          }
        });
        
        plus.addEventListener('click', function(e) {
          e.preventDefault();
          quantity += 1;
          
          disableItem(item, true);
          changeCart({ id: variantid, quantity: quantity}, function(obj) {
            updateCartPanel();
            disableItem(item, false);
          });
        });
        
        minus.addEventListener('click', function(e) { 
          e.preventDefault();
          quantity -= 1;
          
          disableItem(item, true);
          changeCart({ id: variantid, quantity: quantity}, function(obj) {
            updateCartPanel();
            disableItem(item, false);
          });
        });
        
        removeItem.addEventListener('click', function(e) {
          e.preventDefault();
          
          disableItem(item, true);
          changeCart({ id: variantid, quantity: 0}, function(obj) {
            updateCartPanel();
            
            try {
              disableItem(item, false);
            } catch (e) { console.log(e); }
          });
        });
        
      })(items[i]);
    }
  }
  
  /**
   * Fill list.
   * @param {function} callback 
   */
  function updateCartPanel(callback) {
    var formatMoney = window.theme.Currency.formatMoney;
    
    getCart(function(json) {
      var items = '';
      var variantid, item, url, image, title, price, quantity;
      
      for (var i = 0; i < json.items.length; i++) {
        item = json.items[i];
        variantid = item.variant_id;
        url = item.url;
        image = item.image;
        title = item.title;
        price = window.theme.Currency.formatMoney(item.price);
        quantity = item.quantity;
          
        items += '' +
          '<div class="item">' + 
            '<div class="image">' +
              '<a href="' + url + '"><img src="' + image + '" alt="' + title + '"></a>' +
            '</div>' +
            '<div class="info">' +
              '<a class="name" href="' + url + '">' + title + '</a>' +
              '<span class="price">' + price + '</span>' +
              '<div class="controls">' +
          	    '<div class="button minus">-</div>' +
                '<input data-variantid="' + variantid + '" pattern="[0-9]*" type="text" value="' + quantity + '">' +
          	    '<div class="button plus">+</div>' +
        	  '</div>' +
            '</div>' +
          	'<div class="remove-item">Sacar del carrito</div>'+
          '</div>';
      }
      
      listing.innerHTML = items;
      priceEl.innerHTML = formatMoney(json.items_subtotal_price);
      shippingEl.innerHTML = formatMoney(getPriceFromWeight(json.total_weight));
      
      recognizeItems();
      
      if ("function" === typeof callback) {
        callback();
      }
    });
  }
  
  
  // Handler events.
  closeBtn.addEventListener('click', function(e) {
    e.preventDefault();
    toggleCart();
  });
  
  if (cartBtn) {
    cartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      toggleCart();
    });
  }
  
  if (addCartBtn) {
    addCartBtn.addEventListener('click', function(e) {
      toggleCart();
    });
  }
  
  // updateCartPanel();
  
})();